import { api } from "../lib/apiClient";


/** POST /ciaov2_parent_coach_registration  →  add parent coach email registration */
export async function addEmail(payload) {
  await api.post(`/ciaov2_parent_coach_registration`, payload);
}
export async function askForPremium(ask_for_premium_reason) {
  const { data } = await api.post(`/parentcoach/ask_for_premium`, { ask_for_premium_reason });
  return data
}
